import React from 'react'
import styled from 'styled-components'

import { fadeOut } from '../../../animations'
import LoaderArrow from './LoaderArrow'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
	background-color: ${props => props.theme.secondary.bg2};
	width: 100%;
	height: 100vh;
	z-index:1000;
  display: flex;
  align-items: center;
  justify-content: center;

	.inner {
    flex: 0 0 12.5em;
    width: 12.5em;
    text-align: center;
    position: relative;

		svg, img {
			width: 100%;
		}

		svg {
      position: absolute;
      top: 0;
      left: 0;
		}

		img {
			position: relative;
		}
	}

	.vu-bg {
		fill: none;
	}

	.vu-line {
		fill: none;
		stroke-width: 4;
		stroke: #FFF;
	}
	.vu-cover {
		fill: #3478de;
	}

	.vu-outer {
		fill: none;
		stroke: #FFF;
		stroke-width: 4;
	}
	
	.vu-char {
		fill: #FFF;
		stroke: #FFF;
	}

	#vu-text * {
    fill: rgba(255,255,255,0.8);
    stroke: none;
  }
`

export default class Loader extends React.Component {
  componentWillLeave(cb) {
    fadeOut(this.wrapper, 0.5, cb)
  }
  render() {
    return(
      <Wrapper innerRef={el => this.wrapper = el}>
        <div className="inner">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1141 1046">
            <path d="M1120.7 955c0 31.9-25.9 57.5-57.9 57.5H79.8c-31.9 0-58.1-25.6-58.1-57.5V82.8c0-31.9 26.2-58.3 58.1-58.3h983c31.9 0 57.9 26.4 57.9 58.3V955z" className="vu-bg"/>
          </svg>
          <LoaderArrow/>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1141 1046">
            <rect x="17.7" y="597.5" width="1099" height="385" className="vu-cover"/>
            <line x1="37.7" y1="599.5" x2="1105.7" y2="599.5" className="vu-line"/>
            <path d="M21.5 1.5c-11 0-20 9-20 20v1002.6c0 11 9 20 20 20h1098c11 0 20-9 20-20V21.5c0-11-9-20-20-20H21.5zM1106.1 952.6c0 11-9 20-20 20H58.1c-11 0-20-9-20-20V61.2c0-11 9-20 20-20h1028.1c11 0 20 9 20 20V952.6z" className="vu-outer"/>
            <g id="vu-ruler">
              <line x1="179.5" y1="336.9" x2="216" y2="373.6" className="vu-line"/>
              <line x1="222.4" y1="303.5" x2="255" y2="343.6" className="vu-line"/>
              <line x1="282.3" y1="259.7" x2="314" y2="306.6" className="vu-line"/>
              <line x1="324.2" y1="263.7" x2="338.8" y2="293" className="vu-line"/>
              <line x1="354.4" y1="230.4" x2="373.7" y2="277.1" className="vu-line"/>
              <line x1="409.2" y1="230.4" x2="419.5" y2="260.6" className="vu-line"/>
              <line x1="458.5" y1="198.6" x2="470" y2="247.8" className="vu-line"/>
              <line x1="527.6" y1="189.8" x2="531.5" y2="239.5" className="vu-line"/>
              <line x1="602.3" y1="189.8" x2="602.3" y2="239.4" className="vu-line"/>
              <line x1="638.9" y1="214.6" x2="634.8" y2="242.6" className="vu-line"/>
              <line x1="688.1" y1="202.6" x2="680.1" y2="250.6" className="vu-line"/>
              <line x1="739.8" y1="228.6" x2="735" y2="242.6" className="vu-line"/>
              <line x1="792.2" y1="235.6" x2="784.3" y2="258.2" className="vu-line"/>
              <line x1="890.8" y1="284.4" x2="877.3" y2="304.3" className="vu-line"/>
              <path d="M679.7 250.2c-153.3-32.6-321 0.4-474.7 132.7l-36.5-35" className="vu-line"/>
              <path d="M979 352.7l-17.1 17.1 -13.1 13.1c-82.6-65.3-172-112-269.1-132.7" className="vu-line"/>
              <path d="M961.9 369.8c-54.4-58.4-182.9-126.7-278.4-139.5" className="vu-line"/>
              <path d="M153.8 325.8c0.6-4 1-7.9-2.1-11.1 -2.6-2.7-6.2-3.2-8.8-0.7 -2.7 2.6-2.4 5.5-0.7 8.6l-3.8 0.9c-2.5-4.3-2.2-9.4 1.5-12.8 4.4-4.2 10.1-3.4 14.7 1.4 4.7 4.9 4.1 10 3.2 15.5 -0.8 4.6-0.9 8.7 1.7 12.4l11.5-11 3.3 3.4 -14.7 14C152.6 339 152.8 331.9 153.8 325.8z" className="vu-char"/>
              <path d="M163.8 315.6c-5.9-6.2-12.4-15.9-6.3-21.8 5.9-5.6 14.9 0.3 21.5 7.2 5.9 6.2 12.3 16 6.3 21.8C179.5 328.4 170.5 322.5 163.8 315.6zM176.2 303.7c-5.3-5.5-11.8-10.3-15.6-6.7 -4 3.8 1.2 10.9 6 15.9 5.3 5.5 11.7 10.3 15.6 6.6C186.1 315.7 181 308.7 176.2 303.7z" className="vu-char"/>
              <path d="M190.2 278.4l-4 3 -2-2.6c2.4-1.8 3.5-4 2.1-7.3l2.2-1.6 23.4 31 -3 2.3L190.2 278.4z" className="vu-char"/>
              <path d="M205.3 281.4c-5.2-6.8-10.5-17.3-3.7-22.4 6.5-4.9 14.8 2 20.5 9.7 5.2 6.8 10.4 17.3 3.7 22.4C219.4 296 211.2 289.2 205.3 281.4zM219 271.1c-4.6-6.1-10.5-11.6-14.7-8.5 -4.4 3.3-0.1 10.9 4.1 16.5 4.6 6.1 10.5 11.6 14.7 8.4C227.5 284.2 223.2 276.6 219 271.1z" className="vu-char"/>
              <path d="M259 223.9l-4.3 2.7 -1.7-2.8c2.5-1.6 3.8-3.7 2.7-7.1l2.3-1.5 20.8 32.8 -3.2 2L259 223.9z" className="vu-char"/>
              <path d="M340.1 218.8l0.7-4.3c2.3 1.1 4.7 1.9 8.2 0.5 4-1.6 5.4-6.3 3.6-10.8 -1.8-4.5-5.3-6.7-8.8-5.3 -2.6 1.1-4 3.2-4.5 5.2l-4.1-0.2 -5.7-18.9 15-6 1.7 4.2 -11.9 4.8 3.3 11.3c0.8-2.1 2.6-3.9 4.9-4.8 5.5-2.2 11.1 1.6 13.6 8 2.8 6.9 1 14.2-5.4 16.7C346.2 220.9 342.2 220.1 340.1 218.8z" className="vu-char"/>
              <path d="M443.5 181.2l3-2.6c2.4 4 5.1 5.2 8.1 4.5 3.4-0.8 5.8-3.6 4.7-8.3 -1-4-3.6-6.4-7.7-5.4l-2.1 0.5 -1.1-4.4 1.9-0.5c3.1-0.7 4.6-3.7 3.7-7.2 -0.9-3.8-3.6-5.7-6.5-5 -3.2 0.8-4.3 3.8-4.6 6.5l-3.8-0.9c0.3-4.6 2.5-8.9 7.4-10 5.1-1.2 9.9 2.1 11.3 7.9 0.8 3.4 0.2 6.9-1.8 9.1 3.4 0.8 6.1 3.6 7.2 8.3 1.7 7-1.8 12.5-7.4 13.8C450.2 188.9 446.2 185.9 443.5 181.2z" className="vu-char"/>
              <path d="M524.7 160.1c3-2.8 5.7-5.5 5.4-9.9 -0.3-3.7-2.8-6.4-6.4-6.1 -3.7 0.3-5.4 2.7-5.9 6.2l-3.5-1.7c0.8-4.8 4.2-8.6 9.2-9 6-0.5 10 3.8 10.5 10.4 0.5 6.8-3.1 10.3-7.3 14.1 -3.5 3.1-6.2 6.2-6.5 10.7l15.9-1.3 0.4 4.7 -20.3 1.6C515.5 169.7 520.1 164.2 524.7 160.1z" className="vu-char"/>
              <path d="M602.9 147.9l-5 0 0-3.3c3 0 5.2-1.1 6.1-4.5l2.7 0 -0.3 38.9 -3.8 0L602.9 147.9z" className="vu-char"/>
              <path d="M684.1 169.8c1.7-8.4 6-19.3 14.3-17.6 8 1.6 8.3 12.4 6.4 21.8 -1.7 8.4-6.1 19.3-14.4 17.6C682.5 190 682.2 179.3 684.1 169.8zM700.9 173.2c1.5-7.5 1.8-15.6-3.4-16.6 -5.4-1.1-8.3 7.2-9.7 14 -1.5 7.5-1.7 15.5 3.5 16.6C696.7 188.2 699.5 180 700.9 173.2z" className="vu-char"/>
              <path d="M805.9 193.9l-4.7-1.8 1.2-3.1c2.8 1.1 5.2 0.9 7.3-2.1l2.5 1 -14.2 36.2 -3.5-1.4L805.9 193.9z" className="vu-char"/>
              <path d="M908.5 260c4.1 0 8-0.3 10.6-3.8 2.3-2.9 2.2-6.6-0.7-8.8 -2.9-2.3-5.8-1.6-8.6 0.6l-1.5-3.6c3.8-3.1 8.9-3.6 12.9-0.5 4.8 3.7 4.9 9.5 0.9 14.8 -4.2 5.4-9.2 5.6-14.8 5.6 -4.6-0.1-8.7 0.5-12 3.6l12.7 9.7 -2.9 3.8 -16.1-12.4C895.2 260.8 902.3 259.9 908.5 260z" className="vu-char"/>
              <path d="M986 329.6l3.7 1.3c-2.2 4.1-2 7 0.2 9.3 2.4 2.6 6 3.2 9.5-0.1 3-2.8 3.7-6.3 0.8-9.4l-1.5-1.6 3.3-3.1 1.3 1.4c2.2 2.3 5.5 2.1 8.1-0.4 2.9-2.7 3.1-5.9 1-8.1 -2.3-2.4-5.5-1.8-7.9-0.7l-1.2-3.7c4.1-2.1 8.9-2.3 12.4 1.3 3.6 3.8 3.1 9.6-1.2 13.7 -2.5 2.4-5.9 3.7-8.8 3 1 3.4-0.1 7.1-3.5 10.4 -5.2 4.9-11.7 4.7-15.7 0.6C982.7 339.3 983.3 334.4 986 329.6z" className="vu-char"/>
              <path d="M1022.2 372.9l-2.4-2.9 8.2-6.9 -5.3-6.3 3.6-3 5.3 6.3 8.2-6.9 2.4 2.9 -8.2 6.9 5.3 6.3 -3.6 3 -5.3-6.3L1022.2 372.9z" className="vu-char"/>
            </g>
            <g id="vu-screw">
              <path d="M628.8 868.3c0 29.7-24.1 53.8-53.8 53.8 -29.7 0-53.7-24.1-53.7-53.7 0-29.7 24.1-53.8 53.7-53.8C604.8 814.5 628.8 838.6 628.8 868.3z" className="vu-line"/>
              <path d="M608.9 868.3c0 18.7-15.1 33.8-33.8 33.8 -18.7 0-33.8-15.1-33.8-33.8 0-18.7 15.1-33.8 33.8-33.8C593.7 834.5 608.9 849.6 608.9 868.3z" className="vu-line"/>
              <line x1="543.6" y1="880.7" x2="605.7" y2="854.1" className="vu-line"/>
            </g>
            <g id="vu-text">
              <path d="M458.3 386.2l6.4-3v53.4h-6.4V386.2z"/>
              <path d="M475.1 417.7c0-12.4 6.6-19.8 16.7-19.8s16.7 7.3 16.7 19.8c0 12.4-6.6 19.8-16.7 19.8S475.1 430.2 475.1 417.7zM502.1 417.6c0-8.6-3.8-13.8-10.2-13.8s-10.2 5.1-10.2 13.9c0 8.6 3.8 13.8 10.2 13.8C498.2 431.5 502.1 426.3 502.1 417.6z"/>
              <path d="M540.3 433.1c-2.5 2.4-6.2 4.4-10.7 4.4 -7.7 0-13.2-4.3-13.2-12.7 0-8.7 6.8-12.5 14.1-12.5 3.3 0 6.7 0.7 9.8 2.4v-2.7c0-6.7-3.3-8.5-8.2-8.5 -4.2 0-8.2 1.8-11 3.8l-1.8-5.4c3-2 8-4 13.7-4 5.9 0 13.5 2 13.5 13.6v25.1h-6.1V433.1zM540.3 426.8v-6.5c-2.3-1.4-5.8-2.5-8.9-2.5 -4.9 0-9 2.1-9 7 0 4.2 2.9 7 8.1 7C534.8 431.8 538.2 429.3 540.3 426.8z"/>
              <path d="M555.3 417.6c0-12.4 6.2-19.8 15.6-19.8 4.4 0 7.4 1.6 9.5 3.6v-15.2l6.4-3v53.4h-6.4v-3c-2.1 2.2-5 3.8-9.5 3.8C561.3 437.5 555.3 429.9 555.3 417.6zM580.5 426.4v-17.8c-1.4-2.2-4.3-4.8-8.7-4.8 -6.4 0-10 5-10 13.8 0 7.8 3.8 13.8 10 13.8C575.4 431.5 578.6 429.6 580.5 426.4z"/>
              <path d="M598.4 387.9c0-2.3 1.8-4.1 4-4.1 2.3 0 4.1 1.9 4.1 4.1 0 2.2-1.8 4-4.1 4C600.2 391.9 598.4 390.1 598.4 387.9zM599.2 398.8h6.4v37.8h-6.4V398.8z"/>
              <path d="M641.2 413.7c0-7.2-3.5-9.9-8.1-9.9 -5 0-8.7 2.4-8.7 9.8v23h-6.4v-37.8h6.4v3.8c2.4-3.3 5.7-4.7 9.8-4.7 8.6 0 13.5 4.7 13.5 16.9v21.8h-6.4V413.7z"/>
              <path d="M668.1 446.9c11.7-0.7 14.5-4.4 14.5-9.4v-4.6c-2.1 3-5.2 4.6-9.8 4.6 -8.4 0-15.5-6.7-15.5-19.8 0-12.4 6.4-19.8 15.7-19.8 5.1 0 8.1 2.4 9.5 4v-3.1h6.4v36.3c0 12.3-7.3 16.3-17.8 16.9L668.1 446.9zM682.6 426.2v-17.3c-1.8-3.1-5.5-5-8.4-5 -6.7 0-10.3 5-10.3 13.8 0 8.7 4.2 13.8 10.3 13.8C677.3 431.5 680.7 429.5 682.6 426.2z"/>
            </g>
          </svg>
        </div>
      </Wrapper>
    )
  }	
}


// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/loader/Loader.js